<div class="grid">
    <div class="col-12">
      <h1 class="titulo-pagina">{{ 'SARLAFT.LBL_SARLAFT' | translate }}</h1>
    </div>
    <div class="col-12">
      <p-tabView>
        <p-tabPanel header="{{ 'SARLAFT.LBL_NIVELES' | translate }}">
          <app-sarlaft-niveles></app-sarlaft-niveles>
        </p-tabPanel>
        <p-tabPanel header="{{ 'SARLAFT.LBL_VARAIBLES' | translate }}">
          <app-sarlaft-variables></app-sarlaft-variables>
        </p-tabPanel>
      </p-tabView>
    </div>
</div>
